export default {
    SET_RESERVATION: 'SET_RESERVATION_DATES',
};



// WEBPACK FOOTER //
// ./src/reducers/ReservationsReducer/ReservationsConstants.js